module.exports = __webpack_public_path__ + "img/01宋雷.6cd04f8f.jpg";